// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "./utils/dialog";
import "@/assets/css/global.css";
import * as echarts from "echarts";
//import china from 'echarts/map/js/china.js'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false;

Vue.prototype.abc = "123123";

import animate from "animate.css";
// import echarts from "echarts"
// Vue.prototype.$echarts = echarts;

// 小数保留四位
Vue.prototype.getFloat = function(num) {
  if (num == 0) {
    return num;
  } else if (!num) {
    return "--";
  } else {
    num = Math.round(num * Math.pow(10, 4)) / Math.pow(10, 4);
    num = Number(num).toFixed(4);
    return num;
  }
};
Vue.prototype.floatObj = function() {
    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
      return Math.floor(obj) === obj
  }

  /*
   * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
   * @param floatNum {number} 小数
   * @return {object}
   *   {times:100, num: 314}
   */
  function toInteger(floatNum) {
      var ret = {times: 1, num: 0}
      var isNegative = floatNum < 0
      if (isInteger(floatNum)) {
          ret.num = floatNum
          return ret
      }
      var strfi  = floatNum + ''
      var dotPos = strfi.indexOf('.')
      var len    = strfi.substr(dotPos+1).length
      var times  = Math.pow(10, len)
      var intNum = parseInt(Math.abs(floatNum) * times + 0.5, 10)
      ret.times  = times
      if (isNegative) {
          intNum = -intNum
      }
      ret.num = intNum
      return ret
  }

  /*
   * 核心方法，实现加减乘除运算，确保不丢失精度
   * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
   *
   * @param a {number} 运算数1
   * @param b {number} 运算数2
   * @param digits {number} 精度，保留的小数点数，比如 2, 即保留为两位小数
   * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
   *
   */
  function operation(a, b, digits, op) {
      var o1 = toInteger(a)
      var o2 = toInteger(b)
      var n1 = o1.num
      var n2 = o2.num
      var t1 = o1.times
      var t2 = o2.times
      var max = t1 > t2 ? t1 : t2
      var result = null
      switch (op) {
          case 'add':
              if (t1 === t2) { // 两个小数位数相同
                  result = n1 + n2
              } else if (t1 > t2) { // o1 小数位 大于 o2
                  result = n1 + n2 * (t1 / t2)
              } else { // o1 小数位 小于 o2
                  result = n1 * (t2 / t1) + n2
              }
              return result / max
          case 'subtract':
              if (t1 === t2) {
                  result = n1 - n2
              } else if (t1 > t2) {
                  result = n1 - n2 * (t1 / t2)
              } else {
                  result = n1 * (t2 / t1) - n2
              }
              return result / max
          case 'multiply':
              result = (n1 * n2) / (t1 * t2)
              return result
          case 'divide':
              result = (n1 / n2) * (t2 / t1)
              return result
      }
  }

  // 加减乘除的四个接口
  function add(a, b, digits) {
    // debugger;
      return operation(a, b, digits, 'add')
  }
  function subtract(a, b, digits) {
      return operation(a, b, digits, 'subtract')
  }
  function multiply(a, b, digits) {
      return operation(a, b, digits, 'multiply')
  }
  function divide(a, b, digits) {
      return operation(a, b, digits, 'divide')
  }
  return {
    add: add,
    subtract: subtract,
    multiply: multiply,
    divide: divide
}
}();

import CnRegionPicker from "cn-region-picker";
Vue.use(CnRegionPicker);

// element-ui 注册
import ElementUI from "element-ui"; //element-ui的全部组件
import "element-ui/lib/theme-chalk/index.css"; //element-ui的css
Vue.use(ElementUI); //使用elementUI

// Table组件 注册
import STable from "./components/STable";
Vue.component("STable", STable);

// Form组件 注册
import SForm from "./components/SForm";
Vue.component("SForm", SForm);

// Tree组件 注册
import STree from "./components/STree";
Vue.component("STree", STree);

// TreeNew组件 注册
import StreeNew from "./components/StreeNew";
Vue.component("StreeNew", StreeNew);

// City组件 注册
import SCity from "./components/SCity";
Vue.component("SCity", SCity);

import CAlarmItem from "./components/CAlarmItem";
Vue.component("CAlarmItem", CAlarmItem);

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  animate,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js